import { useGraphQLQuery } from '@opengov/bnp-core';
import isEmpty from 'lodash/isEmpty';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { graphql } from '../../../../../../gql-generated/hasura';
import { useToast } from '../../../../Toast/context/useToast.context';
import locale from '../../customReports-locale.json';
import { editCustomSpreadsheetModalQueryKeys } from './editCustomSpreadsheetModalQueryKeys';

const FetchStoryContentSpreadsheetReferencesQuery = graphql(`
  query GetStoryContentSpreadsheetReferences($storyContentId: String!) {
    storyContentSpreadsheetReferences(where: { storyContentId: { _eq: $storyContentId } }) {
      namedRangeId
      spreadsheetId
      title
    }
  }
`);

export function useFetchStoryContentSpreadsheetReferences({
  storyContentId,
  onSuccess
}: {
  storyContentId: string;
  onSuccess?: (data: Array<{ namedRangeId: string; spreadsheetId: string; title?: string | null }>) => void;
}) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: editCustomSpreadsheetModalQueryKeys.storyContentSpreadsheetReferences(storyContentId),
    variables: { storyContentId: storyContentId },
    document: FetchStoryContentSpreadsheetReferencesQuery,
    url: HASURA_SERVICE_URL,
    options: {
      enabled: !isEmpty(storyContentId),
      select: (data) => data.storyContentSpreadsheetReferences,
      onSuccess: onSuccess,
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchCustomReports,
          severity: 'error'
        });
      }
    }
  });
}
